import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { InfoWindow as VisInfoWindow } from '@vis.gl/react-google-maps';
export const InfoWindow = ({ children, marker, position, visible, onClose }) => {
    if (!visible) {
        return null;
    }
    return (_jsx(VisInfoWindow, { anchor: marker, position: marker ? undefined : position, onCloseClick: onClose, children: children }));
};
